
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Dadartopunecab() {



    const cardData =
    {
        keyword: 'Dadar to Pune Cab',
        heading: 'Skyline Cabs: Dadar to Pune Cab',
        headingDescription: 'Skyline Cabs offers dependable and comfortable Dadar to Pune Cab services for all your travel needs. Whether you are heading to Pune for work, leisure, or a family visit, our professional drivers and well-maintained vehicles ensure a safe and smooth ride. With on-time pickups from Dadar and 24/7 customer support, we make your intercity journey hassle-free. Book your Dadar to Pune cab with Skyline Cabs today and enjoy a relaxed and affordable travel experience.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Dadar to Pune Taxi Charges",
      "description": "Skyline Cabs offers transparent and competitive pricing for Dadar to Pune taxi services. Our fares include fuel, tolls, and driver charges with no hidden fees. Choose from sedans, Ertiga, or Innova Crysta based on your comfort and travel needs."
    },
    {
      "name": "Dadar to Pune Taxi Service",
      "description": "Get a reliable and punctual taxi from Dadar to Pune with Skyline Cabs. Whether for a one-way trip or return journey, we offer well-maintained vehicles and professional drivers to ensure a smooth and safe travel experience."
    },
    {
      "name": "Cab from Dadar to Pune",
      "description": "Skyline Cabs provides comfortable cab services from Dadar to Pune, ideal for business, leisure, or airport transfers. Book sedans, SUVs, or MPVs and enjoy a hassle-free journey with on-time pickups and courteous chauffeurs."
    },
    {
      "name": "Dadar Pune Cab Service",
      "description": "Book your Dadar to Pune cab with Skyline Cabs for dependable travel. Our fleet includes Swift Dzire, Ertiga, and Innova Crysta. Get clean vehicles, 24/7 availability, and prompt service at affordable prices."
    },
    {
      "name": "Dadar Pune Taxi",
      "description": "Looking for a taxi from Dadar to Pune? Skyline Cabs offers daily services with quick booking options, experienced drivers, and competitive rates for both one-way and round-trip rides."
    },
    {
      "name": "Mumbai to Pune Taxi from Dadar",
      "description": "Travel from Dadar, Mumbai to Pune comfortably with Skyline Cabs. Our services are perfect for solo travelers, families, or corporate clients. Book sedans, Ertiga, or Innova for a smooth ride."
    },
    {
      "name": "Pune to Dadar Taxi",
      "description": "Need a taxi from Pune to Dadar? Skyline Cabs provides reliable one-way or round-trip taxi options. Choose the car type that suits your travel plans and enjoy timely pickups and professional service."
    },
    {
      "name": "Taxi Fare from Dadar to Pune",
      "description": "Our Dadar to Pune taxi fare is designed to be affordable and clear. No surprise charges—just clean, AC vehicles with GPS tracking and experienced drivers for a safe ride."
    },
    {
      "name": "Dadar to Pune Ertiga Cab",
      "description": "Skyline Cabs offers Ertiga cab services from Dadar to Pune for comfortable and spacious travel. Ideal for small groups and families, Ertiga provides great mileage and a smooth ride."
    },
    {
      "name": "Dadar to Pune Innova Cab",
      "description": "Travel in style with our Innova or Innova Crysta cabs from Dadar to Pune. These 7-seater vehicles are perfect for group travel, offering comfort, air-conditioning, and ample space for luggage."
    },
    {
      "name": "Dadar to Pune Sedan Cab",
      "description": "Choose Skyline Cabs’ sedan options like Swift Dzire, Etios, or Xcent for a cost-effective and comfortable journey from Dadar to Pune. Best suited for 2–4 passengers with light luggage."
    },
    {
      "name": "Dadar to Pune Cab Fare",
      "description": "Our cab fare from Dadar to Pune is designed with transparency in mind. You pay only for what you see—tolls, taxes, and driver allowance are all included in the final fare shared upfront."
    },
    {
      "name": "Dadar to Pune Innova Crysta",
      "description": "Skyline Cabs provides premium Innova Crysta rental for Dadar to Pune trips. Perfect for luxury travelers or families, the Crysta offers plush seating, great suspension, and a high-end travel feel."
    },
    {
      "name": "Dadar to Pune Ertiga Cab Fare",
      "description": "Looking for an affordable yet comfortable ride? Our Ertiga cab fare from Dadar to Pune is competitively priced and includes all travel essentials like tolls and fuel."
    },
    {
      "name": "Dadar to Pune Sedan Cab Fare",
      "description": "Get budget-friendly fare for your sedan cab from Dadar to Pune. Our Swift Dzire, Etios, and similar models are ideal for small groups with economical pricing and top-notch comfort."
    },
    {
      "name": "Dadar to Pune Station Cab",
      "description": "Heading to Pune Station from Dadar? Skyline Cabs offers direct, affordable cabs for quick station transfers. Choose from various car types and enjoy timely service and smooth rides."
    },
    {
      "name": "Mumbai to Pune Taxi Fare",
      "description": "Skyline Cabs offers Mumbai to Pune taxi fare plans starting from Dadar or other Mumbai locations. Whether you pick a sedan, Ertiga, or Innova, we provide flat pricing with all charges included."
    },
    {
      "name": "Dadar Taxi Service for Outstation Cabs",
      "description": "Need an outstation cab from Dadar? Skyline Cabs offers trips to Pune and other major cities with comfortable vehicles, reliable drivers, and 24x7 customer support."
    },
    {
      "name": "Dadar to Pune Daily Cab Service",
      "description": "Skyline Cabs provides daily cab services from Dadar to Pune, ensuring consistency and reliability for regular commuters, business travelers, or anyone needing frequent intercity travel."
    },
    {
      "name": "Dadar Cab Service",
      "description": "Skyline Cabs is your trusted cab service provider in Dadar, offering local, intercity, and outstation services. Book a taxi anytime for airport drops, Pune trips, or full-day rentals."
    }
  ],
  "tableData": [
    ["Dadar to Pune Taxi Charges", "Dadar to Pune Taxi Service"],
    ["Cab from Dadar to Pune", "Dadar Pune Cab Service"],
    ["Dadar Pune Taxi", "Dadar to Pune Cab Service"],
    ["Mumbai to Pune Taxi from Dadar", "Pune to Dadar Taxi"],
    ["Taxi Fare from Dadar to Pune", "Dadar to Pune Ertiga Cab"],
    ["Dadar to Pune Innova Cab", "Dadar to Pune Sedan Cab"],
    ["Dadar to Pune Cab Fare", "Dadar to Pune Innova Crysta"],
    ["Dadar to Pune Ertiga Cab Fare", "Dadar to Pune Sedan Cab Fare"],
    ["Dadar to Pune Station Cab", "Mumbai to Pune Taxi Fare"],
    ["Dadar Taxi Service for Outstation Cabs", "Dadar to Pune Daily Cab Service"],
    ["Dadar Cab Service", "Taxi from Dadar to Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Dadar to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers prompt and dependable cab service from Dadar to Pune. Whether you're traveling for business, leisure, or to visit family, we ensure timely pickups and smooth rides. Enjoy peace of mind with our consistent service and experienced drivers."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained sedans, SUVs, and premium cars that ensure a comfortable journey from Dadar to Pune. Every vehicle is cleaned regularly, equipped with air-conditioning, and provides ample legroom and space for luggage."
    },
    {
        "WhyChooseheading": "Professional Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are professionally trained and familiar with the Dadar to Pune route, helping you avoid traffic congestion and ensuring a safe and efficient trip. Courteous and punctual, they are committed to delivering a smooth travel experience."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "Skyline Cabs provides transparent and affordable fare options for your Dadar to Pune ride. There are no hidden fees—what you see is what you pay. Get great service without overspending, and receive a detailed fare quote before your journey begins."
    },
    {
        "WhyChooseheading": "24/7 Availability for Any Travel Schedule",
        "WhyChoosedescription": "Whether you need an early morning cab or a late-night pickup from Dadar, Skyline Cabs is available 24/7. Our round-the-clock availability makes us the perfect travel partner, no matter what time your journey begins."
    },
    {
        "WhyChooseheading": "Multiple Cab Options for Every Need",
        "WhyChoosedescription": "From individual travelers to families or small groups, we have a vehicle that fits your needs. Choose from economy cars, spacious SUVs, or luxurious sedans depending on your travel style and group size."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Tracking",
        "WhyChoosedescription": "Booking a cab from Dadar to Pune is quick and simple with Skyline Cabs. Use our mobile app or website for hassle-free booking, instant confirmation, and real-time tracking of your driver for a worry-free travel experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Ride Every Time",
        "WhyChoosedescription": "Your safety is our top priority. All our cabs are GPS-enabled, and our drivers are background-verified. Whether you're traveling during the day or night, Skyline Cabs ensures a safe and secure journey from Dadar to Pune."
    }
]















    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Dadar to Pune with Skyline Cabs?',
            answer:
                'Booking is easy! Visit our website or mobile app, enter Dadar as the pickup point and Pune as the destination, select your preferred vehicle, and confirm the booking instantly.',
        },
        {
            id: 2,
            question: 'What cab options are available for Dadar to Pune travel?',
            answer:
                'Skyline Cabs offers a wide range of vehicles such as Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose one based on your group size and comfort preference.',
        },
        {
            id: 3,
            question: 'Is the fare from Dadar to Pune fixed?',
            answer:
                'Yes, all our fares are fixed and fully transparent. The price includes tolls, driver charges, and taxes — so no surprises at the end of your trip.',
        },
        {
            id: 4,
            question: 'Can I book a round trip from Dadar to Pune?',
            answer:
                'Absolutely! You can opt for both one-way and round-trip bookings. Just mention your return plan at the time of booking, and we’ll take care of the rest.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Dadar to Pune?',
            answer:
                'The journey usually takes around 3.5 to 4 hours, depending on traffic. Our drivers take the best routes to ensure a smooth and timely arrival.',
        },
        {
            id: 6,
            question: 'Are Skyline drivers experienced and punctual?',
            answer:
                'Yes, our drivers are background-verified, experienced in long-distance travel, and always punctual. Expect professional and courteous service throughout your journey.',
        },
        {
            id: 7,
            question: 'Do you offer airport transfers from Dadar to Pune?',
            answer:
                'Yes, we provide airport pickup and drop services. If you are flying into Mumbai and need a cab from Dadar to Pune, Skyline Cabs has you covered.',
        },
        {
            id: 8,
            question: 'What safety measures are followed during the trip?',
            answer:
                'All our vehicles are regularly sanitized, air-conditioned, and maintained for safety. Our drivers follow all traffic regulations and prioritize passenger well-being.',
        },
        {
            id: 9,
            question: 'Can I make changes to my Dadar to Pune booking?',
            answer:
                'Yes, you can modify or cancel your trip via our app, website, or by calling customer support. We offer flexible booking policies to suit your changing plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs from Dadar to Pune?',
            answer:
                'Skyline Cabs stands out for punctuality, vehicle cleanliness, professional drivers, and clear pricing. Whether it’s a business trip or family outing, we make your journey smooth and comfortable.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sameer Mehta",
            rating: 5,
            review: "I had a great experience with Skyline Cabs from Dadar to Pune. The car was clean, the driver was on time, and I was able to relax the entire way. Professional service — will definitely book again!"
        },
        {
            name: "Miss. Ananya Bhosale",
            rating: 4,
            review: "Booked a cab from Dadar to Pune for a weekend getaway. It was a smooth ride, and the driver was courteous and knowledgeable. Would love more in-car amenities, but overall very satisfied with the service!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Dadar to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/dadar-to-pune-cab.jpg",
  "description": "Book Dadar to Pune cabs with Skyline Cabs for a reliable, affordable, and comfortable journey. Choose from AC sedans and SUVs with professional drivers, available 24/7 for one-way or round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7689"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/dadar-to-pune-cabs"
  }
};


      
    
      


    return (
        <div>

<Helmet>
  <title>Dadar to Pune Cabs | 24/7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Dadar to Pune cabs with Skyline Cabs for a reliable, affordable, and comfortable journey. Choose from AC sedans and SUVs with professional drivers, available 24/7 for one-way or round trips." 
  />
  <meta 
    name="keywords" 
    content="Dadar to Pune Cabs, Cab from Dadar to Pune, One-Way Taxi Dadar to Pune, Round Trip Cab Dadar to Pune, AC Cab Dadar to Pune, SUV Taxi Dadar to Pune, Skyline Cabs Dadar to Pune, 24/7 Cab Booking Dadar to Pune, Online Cab Dadar to Pune, Affordable Taxi Dadar to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/31.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Dadartopunecab;